import { Component, Output, Input, EventEmitter, AfterViewInit, ViewChild } from '@angular/core';
import { Searchbar } from 'ionic-angular';

@Component({
  selector: 'companies-list',
  templateUrl: 'companies-list.html',
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompaniesListComponent implements AfterViewInit {
  @Output() goToCompany: EventEmitter<any> = new EventEmitter();
  @ViewChild(Searchbar) searchbar: Searchbar;
  searchTerm: string = '';
  filteredCompanies: any = [];
  @Input() companies:any;
  loading: boolean = true;
  constructor() {

  }
  ngAfterViewInit() {
    this.setFilteredItems(this.companies);
    setTimeout(f => {
      this.searchbar.setFocus();
      this.loading = false;
    }, 500)
  }

  goCompany($event, resource) {
    this.goToCompany.emit($event);
  }
  resetFilter() {
    this.searchTerm = '';
  }
  setFilteredItems(companies) {
    this.filteredCompanies = this.filterItems(companies, this.searchTerm);
  }

  onSearchInput() {
    this.setFilteredItems(this.companies);
  }

  filterItems(companies, searchTerm) {
    if (!companies) {
      return [];
    }

    return this.companies.filter((item) => {
      return (item.name.toLowerCase() + item.ticker.toLowerCase()).indexOf(searchTerm.toLowerCase()) > -1;
    }).slice(0, 20) || [];
  }

  trackCompany(index, company) {
    return company ? company.ticker : undefined;
  }

}



// WEBPACK FOOTER //
// ./src/components/companies-list/companies-list.ts